/* ARCANIS · Mirror + Leather · behaviours (vanilla, no dependency) */
(function () {
  const I18N = Object.assign({ unavailable: 'Unavailable', on_request: 'On request', limited_to: 'Limited to %n', complete: 'Complete · %n', eta: 'Estimated delivery', eta_to: 'to', cart: 'Cart' }, window.arcI18n || {});
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- header + menu ---------- */
  function initHeader() {
    const header = $('.arc-header');
    if (!header || header.dataset.arcHeaderInit) return;
    header.dataset.arcHeaderInit = '1';
    const menu = $('.arc-menu');
    const burger = $('.arc-burger', header);
    if (burger && menu) {
      burger.addEventListener('click', () => {
        const open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        header.classList.toggle('menu-open', open);
        burger.setAttribute('aria-expanded', String(open));
        document.documentElement.style.overflow = open ? 'hidden' : '';
      });
    }
    if (header.classList.contains('arc-header--overlay')) {
      const onScroll = () => header.classList.toggle('is-solid', window.scrollY > 40);
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
    /* the bar comes back as soon as the visitor scrolls up, anywhere on the page, and leaves when they scroll down */
    /* a solid header sits in the page flow: keep its room when it turns fixed, so the page does not jump */
    const holder = header.closest('.shopify-section');
    const keepRoom = () => { if (holder && !header.classList.contains('arc-header--overlay')) holder.style.minHeight = header.offsetHeight + 'px'; };
    keepRoom(); window.addEventListener('resize', keepRoom);
    let lastY = window.scrollY, ticking = false;
    const pin = () => {
      ticking = false;
      const y = window.scrollY, dy = y - lastY;
      if (header.classList.contains('menu-open')) { lastY = y; return; }
      if (y < 120) header.classList.remove('is-pinned');
      else if (dy < -6) header.classList.add('is-pinned');
      else if (dy > 6) header.classList.remove('is-pinned');
      if (Math.abs(dy) > 6) lastY = y;
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(pin); } }, { passive: true });
    const cart = $('.arc-cart', header);
    if (cart) {
      fetch(cart.getAttribute('href') + '.js', { headers: { Accept: 'application/json' } }).then(r => { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); }).then(c => {
        cart.dataset.count = c.item_count; const cc = cart.querySelector('[data-arc-cart-count]'); if (cc) cc.textContent = c.item_count; else cart.textContent = I18N.cart + ' · ' + c.item_count;
      }).catch(() => {});
    }
  }

  /* ---------- reveal ---------- */
  function initReveal() {
    const els = $$('.arc-reveal');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(e => io.observe(e));
  }

  /* ---------- money ---------- */
  function money(cents, currency, format) {
    // Same output as Liquid money_without_trailing_zeros, from the shop money format
    if (format && /\{\{\s*\w+\s*\}\}/.test(format)) {
      const key = format.match(/\{\{\s*(\w+)\s*\}\}/)[1];
      const n = cents / 100;
      const fixed = (dec, thou, decsep) => {
        const parts = Math.abs(n).toFixed(dec).split('.');
        const int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return (n < 0 ? '-' : '') + (parts[1] ? int + decsep + parts[1] : int);
      };
      const table = {
        amount: [2, ',', '.'], amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','], amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'], amount_no_decimals_with_apostrophe_separator: [0, "'", '.'],
        amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','],
        amount_with_period_and_space_separator: [2, ' ', '.']
      };
      const t = table[key] || table.amount;
      const s = fixed(t[0], t[1], t[2]).replace(/([.,])00$/, '');
      return format.replace(/\{\{\s*\w+\s*\}\}/, s).replace(/<[^>]+>/g, '').trim();
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: currency || 'EUR', maximumFractionDigits: 0 }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(0) + ' ' + (currency || ''); }
  }

  /* ---------- delivery estimate: business days from today, as dates ---------- */
  function etaText(min, max) {
    const add = (n) => { const d = new Date(); let k = 0; while (k < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) k++; } return d; };
    const a = add(min), b = add(max);
    const lang = document.documentElement.lang || 'en';
    const full = (d) => new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' }).format(d);
    const month = (d) => new Intl.DateTimeFormat(lang, { month: 'long' }).format(d);
    const same = a.getMonth() === b.getMonth();
    if (!same) return I18N.eta + ' ' + full(a) + ' ' + I18N.eta_to + ' ' + full(b);
    return I18N.eta + ' ' + (lang.indexOf('en') === 0 ? month(a) + ' ' + a.getDate() + ' ' + I18N.eta_to + ' ' + b.getDate() : a.getDate() + ' ' + I18N.eta_to + ' ' + b.getDate() + ' ' + month(a));
  }
  function initEta(scope) {
    $$('[data-arc-eta]', scope || document).forEach(e => {
      const min = Number(e.dataset.arcMin || 8), max = Number(e.dataset.arcMax || 15);
      try { e.textContent = etaText(min, max); } catch (err) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initEta()); else initEta();

  /* ---------- cart drawer and cart page ---------- */
  function initCart() {
    const roots = $$('[data-arc-cart-root]');
    if (!roots.length) return;
    const drawer = $('[data-arc-drawer]');
    const cartPath = roots[0].dataset.arcCartUrl || $('.arc-cart')?.getAttribute('href') || '/cart';
    const addPath = roots[0].dataset.arcCartAdd || cartPath + '/add.js';
    const changePath = roots[0].dataset.arcCartChange || cartPath + '/change.js';
    let busy = false;
    const disabledBefore = new WeakMap();
    const refreshVersions = new WeakMap();
    const setCount = (n) => { $$('[data-arc-cart-count]').forEach(e => e.textContent = n); $$('.arc-cart').forEach(a => a.dataset.count = n); };
    const setBusy = (value) => {
      busy = value;
      roots.forEach(root => {
        root.setAttribute('aria-busy', String(value));
        root.querySelectorAll('button:not([data-arc-drawer-close]),input').forEach(el => {
          if (value) { if (!disabledBefore.has(el)) disabledBefore.set(el, el.disabled); el.disabled = true; }
          else if (disabledBefore.has(el)) { el.disabled = disabledBefore.get(el); disabledBefore.delete(el); }
        });
      });
    };
    const setError = (root, message) => {
      const el = root.querySelector('[data-arc-cart-message]');
      if (el) { el.textContent = message || ''; el.classList.toggle('arc-hidden', !message); }
    };
    async function request(path, body) {
      const response = await fetch(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(typeof payload.description === 'string' ? payload.description : typeof payload.message === 'string' ? payload.message : '');
      return payload;
    }
    async function refresh(root) {
      const id = root.dataset.arcSection; if (!id) return;
        const version = (refreshVersions.get(root) || 0) + 1;
        refreshVersions.set(root, version);
        const html = await fetch(cartPath + '?section_id=' + encodeURIComponent(id), { headers: { Accept: 'text/html' } }).then(r => { if (!r.ok) throw new Error(''); return r.text(); });
        if (refreshVersions.get(root) !== version) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nl = doc.querySelector('[data-arc-cart-lines]'), nf = doc.querySelector('[data-arc-cart-foot]'), nc = doc.querySelector('[data-arc-cart-count]');
        const ol = root.querySelector('[data-arc-cart-lines]'), of = root.querySelector('[data-arc-cart-foot]');
        if (!nl || !nf || !ol || !of) throw new Error('');
        if (nl && ol) ol.innerHTML = nl.innerHTML;
        if (nf && of) of.innerHTML = nf.innerHTML;
        const nr = doc.querySelector('[data-arc-cart-recommendations]'), or = root.querySelector('[data-arc-cart-recommendations]');
        if (nr && or) or.innerHTML = nr.innerHTML;
        if (nc) setCount(nc.textContent.trim());
        initEta(root);
        if (busy) setBusy(true);
    }
    async function refreshAll() { await Promise.all(roots.map(refresh)); }
    document.addEventListener('arc:cart-refresh', () => { if (!busy) refreshAll().catch(() => {}); });
    async function mutate(root, path, body, target) {
      if (busy) return;
      const focused = document.activeElement;
      const line = focused?.closest('[data-arc-line]');
      const key = line?.dataset.arcLine;
      const action = focused?.hasAttribute('data-arc-step') ? '[data-arc-step="' + focused.dataset.arcStep + '"]' : focused?.hasAttribute('data-arc-remove') ? '[data-arc-remove]' : null;
      const restoreFocus = root.contains(focused);
      roots.forEach(item => setError(item, ''));
      setBusy(true);
      if (target) target.classList.add('is-busy');
      try {
        const result = await request(path, body);
        if (typeof result.item_count === 'number') setCount(result.item_count);
        await refreshAll();
        if (restoreFocus && !document.contains(focused)) {
          const newLine = Array.from(root.querySelectorAll('[data-arc-line]')).find(item => item.dataset.arcLine === key);
          const next = (newLine && action && newLine.querySelector(action)) || root.querySelector('[data-arc-remove],.arc-cart-empty a,[data-arc-drawer-close]:not(.arc-drawer__backdrop)');
          setBusy(false);
          if (next) next.focus({ preventScroll: true });
        }
      } catch (error) {
        const message = root.dataset.arcCartError || 'We couldn’t update your cart. Please try again.';
        setError(root, error.message && !(error instanceof TypeError) ? error.message : message);
      } finally {
        if (target) target.classList.remove('is-busy');
        setBusy(false);
      }
    }
    roots.forEach(root => {
      root.addEventListener('click', (e) => {
        const add = e.target.closest('[data-arc-add-variant]');
        if (add) {
          mutate(root, addPath, { items: [{ id: Number(add.dataset.arcAddVariant), quantity: 1 }] }, add);
          return;
        }
        const step = e.target.closest('[data-arc-step]'); const rm = e.target.closest('[data-arc-remove]');
        if (!step && !rm) return;
        const line = e.target.closest('[data-arc-line]'); if (!line) return;
        const qty = rm ? 0 : Math.max(0, Number(line.dataset.arcQty) + Number(step.dataset.arcStep));
        mutate(root, changePath, { id: line.dataset.arcLine, quantity: qty }, line);
      });
      root.addEventListener('submit', e => { if (busy) e.preventDefault(); });
    });
    if (!drawer) return;
    let arcFocusReturn = null;
    const open = () => {
      if (drawer.classList.contains('is-open')) return;
      arcFocusReturn = document.activeElement;
      const burger = $('.arc-burger');
      if ($('.arc-menu.is-open') && burger) burger.click();
      if (!busy) refresh(drawer).catch(() => setError(drawer, drawer.dataset.arcCartError));
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); drawer.removeAttribute('inert'); document.documentElement.classList.add('arc-lock');
      const c = drawer.querySelector('[data-arc-drawer-close]:not(.arc-drawer__backdrop)'); if (c) c.focus({ preventScroll: true });
    };
    const close = () => {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.classList.remove('arc-lock');
      if (arcFocusReturn && arcFocusReturn.focus) { try { arcFocusReturn.focus({ preventScroll: true }); } catch (e) {} }
      drawer.setAttribute('inert', '');
    };
    // keep the tab key inside the open drawer
    drawer.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
      const f = [...drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])')].filter(el => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    $$('.arc-cart').forEach(a => a.addEventListener('click', (e) => { if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; e.preventDefault(); open(); }));
    $$('[data-arc-drawer-close]', drawer).forEach(b => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
    window.arcOpenCart = open;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCart); else initCart();

  /* ---------- product ---------- */
  function initProduct(root) {
    const dataEl = $('[data-arc-product-json]', root);
    if (!dataEl || root.dataset.arcProductInit) return;
    let data; try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    root.dataset.arcProductInit = '1';
    const form = $('form[data-arc-form]', root);
    const idInput = form ? $('input[name="id"]', form) : null;
    const selected = data.selected.slice();
    const onRequestAbove = data.on_request_above || 1000000;
    const cartPath = data.cart_url || '/cart';
    const checkoutPath = (data.root_url || '/').replace(/\/?$/, '/') + 'checkout';
    const buyButtons = $$('[data-arc-buy],[data-arc-add]', root);
    const sticky = $('.arc-sticky', root);
    const errorMessage = $('[data-arc-product-error]', root);
    const sizeNotice = $('[data-arc-colour-size-notice]', root);
    let sizeNeedsChoice = new URL(location.href).searchParams.has('arc_size_unavailable');
    let colourways = [];
    try { colourways = JSON.parse($('[data-arc-colourway-variants]', root)?.textContent || '[]'); } catch (e) {}
    const colourOption = /colour|color|couleur|leather|cuir/i;
    const sizeKey = value => {
      const label = String(value || '').trim().toLowerCase();
      const dimensions = label.match(/^(\d+(?:[.,]\d+)?)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*(cm|mm|in)?(?:\s|\||$)/i);
      return dimensions ? dimensions.slice(1).map(v => (v || '').replace(',', '.')).join('x') : label;
    };
    function updateColourways() {
      $$('.arc-colourways a', root).forEach(link => {
        const url = new URL(link.href, location.href);
        const sibling = colourways.find(item => new URL(item.url, location.href).pathname === url.pathname);
        if (!sibling) return;
        const match = !sizeNeedsChoice && sibling.variants.find(variant => variant.available && variant.options.every((value, index) => colourOption.test(sibling.options[index] || '') || sizeKey(value) === sizeKey(selected[index])));
        url.searchParams.delete('variant');
        url.searchParams.delete('arc_size_unavailable');
        if (match) url.searchParams.set('variant', match.id);
        else url.searchParams.set('arc_size_unavailable', '1');
        url.hash = 'arc-hud';
        link.href = url.href;
      });
    }
    let adding = false;
    buyButtons.forEach(button => { button.dataset.arcLabel = button.textContent.trim(); });
    let lastMedia = null;

    function findVariant() {
      return data.variants.find(v => v.options.every((o, i) => o === selected[i]));
    }
    function updateOptionUI() {
      $$('[data-arc-option]', root).forEach(el => {
        const i = Number(el.dataset.arcOption); const val = el.dataset.value;
        el.classList.toggle('is-active', selected[i] === val);
        el.setAttribute('aria-pressed', String(selected[i] === val));
        // availability: is there an available variant with this value and the other selected values?
        const ok = data.variants.some(v => v.available && v.options[i] === val && v.options.every((o, j) => j === i || o === selected[j]));
        el.classList.toggle('is-unavailable', !ok);
        el.setAttribute('aria-label', val + (ok ? '' : ' · ' + I18N.unavailable));
      });
      $$('[data-arc-option-name]', root).forEach(el => { const i = Number(el.dataset.arcOptionName); el.textContent = selected[i]; });
    }
    function render(initial) {
      const v = findVariant();
      updateOptionUI();
      updateColourways();
      if (sizeNotice) sizeNotice.classList.toggle('arc-hidden', !sizeNeedsChoice);
      const priceEls = $$('[data-arc-price]', root);
      const buyEls = $$('[data-arc-buy-zone]', root);
      const reqEls = $$('[data-arc-request-zone]', root);
      const onRequest = !!v && (data.price_on_request || v.price > onRequestAbove);
      const canBuy = !!v && v.available && !onRequest && !sizeNeedsChoice;
      if (idInput) { idInput.value = v ? v.id : ''; idInput.disabled = !canBuy; }
      buyButtons.forEach(button => {
        button.disabled = !canBuy || adding;
        if (sticky?.contains(button)) {
          button.classList.toggle('arc-hidden', onRequest);
          button.textContent = canBuy ? button.dataset.arcLabel : I18N.unavailable;
        }
      });
      $$('[data-arc-sticky-request]', root).forEach(link => link.classList.toggle('arc-hidden', !onRequest));
      $$('[data-arc-soldout]', root).forEach(el => {
        el.classList.toggle('arc-hidden', !!v && v.available);
        el.textContent = I18N.unavailable;
      });
      $$('[data-arc-price-from]', root).forEach(el => el.classList.toggle('arc-hidden', !v || onRequest || v.price === data.price_min));
      if (!v) {
        priceEls.forEach(e => e.textContent = I18N.unavailable);
        buyEls.forEach(e => e.classList.add('arc-hidden'));
        $$('[data-arc-sticky-price]', root).forEach(e => e.textContent = I18N.unavailable);
        $$('[data-arc-sticky-variant]', root).forEach(e => e.textContent = selected.join(' · ').replace(/\s*\|\s*/g, ' · ') + ' · ');
        return;
      }
      const price = v.formatted_price || money(v.price, data.currency);
      priceEls.forEach(e => e.textContent = onRequest ? I18N.on_request : price);
      buyEls.forEach(e => e.classList.toggle('arc-hidden', onRequest || !v.available || sizeNeedsChoice));
      reqEls.forEach(e => e.classList.toggle('arc-hidden', false));
      // edition counter
      // edition size: variant metafield, else "Edition of N" in the size name, else the product value
      let ed = v.edition || 0;
      if (!ed) { const m = /edition\s+of\s+(\d+)/i.exec((v.options || []).join(' ')); if (m) ed = Number(m[1]); }
      if (!ed) ed = data.edition || 0;
      const inv = (typeof v.inventory === 'number') ? v.inventory : null;
      let sold = null;
      if (ed > 0 && inv !== null) sold = Math.max(0, Math.min(ed, ed - inv));
      $$('[data-arc-edition]', root).forEach(e => e.textContent = ed > 0 ? ed : '—');
      $$('[data-arc-sold]', root).forEach(e => e.textContent = sold !== null ? sold : '—');
      // the big counter only once at least one piece is gone: never a fake number, never a zero
      $$('[data-arc-counter]', root).forEach(e => e.classList.toggle('arc-hidden', sold === null || sold <= 0 || ed <= 0));
      $$('[data-arc-edition-row]', root).forEach(e => e.classList.toggle('arc-hidden', ed <= 0));
      $$('[data-arc-edition-line]', root).forEach(e => e.textContent = ed <= 0 ? '' : ((sold !== null && sold >= ed) ? I18N.complete.replace('%n', ed) : I18N.limited_to.replace('%n', ed)));
      // sizes on the wall
      const si = (data.options || []).findIndex(o => /size|taille|format|dimension|größe|grösse|groesse|tamaño|tamanho|grootte|formaat|størrelse|méret|μέγεθος|μεγεθος/i.test(String(o)));
      if (si >= 0) { const sv = selected[si]; $$('[data-arc-size]', root).forEach(el => el.classList.toggle('is-active', el.dataset.arcSize === sv)); }
      // media per variant: only when the chosen variant carries its own image
      if (!initial && v.featured_media && v.featured_media !== lastMedia && $('[data-arc-media-id="' + v.featured_media + '"]', root)) showMedia(root, v.featured_media);
      lastMedia = v.featured_media;
      // url
      try { const u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      // sticky
      $$('[data-arc-sticky-price]', root).forEach(e => e.textContent = onRequest ? I18N.on_request : price);
      $$('[data-arc-sticky-variant]', root).forEach(e => { const t = (v.options || []).filter(o => o && o !== 'Default Title').join(' · ').replace(/\s*\|\s*/g, ' · '); e.textContent = t ? t + ' · ' : ''; });
    }
    $$('[data-arc-option]', root).forEach(el => el.addEventListener('click', (ev) => {
      ev.preventDefault(); selected[Number(el.dataset.arcOption)] = el.dataset.value;
      if (sizeNeedsChoice) {
        sizeNeedsChoice = false;
        const url = new URL(location.href); url.searchParams.delete('arc_size_unavailable'); history.replaceState(null, '', url);
      }
      render();
    }));
    // buy now → cart/add then checkout
    async function addToCart(redirect) {
      const variant = findVariant();
      if (!form || adding || sizeNeedsChoice || !variant || !variant.available || data.price_on_request || variant.price > onRequestAbove) return;
      adding = true;
      if (errorMessage) { errorMessage.textContent = ''; errorMessage.classList.add('arc-hidden'); }
      form.setAttribute('aria-busy', 'true');
      buyButtons.forEach(button => { button.disabled = true; button.classList.add('is-busy'); });
      $$('[data-arc-option]', root).forEach(button => { button.disabled = true; });
      try {
        const fd = new FormData(form);
        fd.set('id', String(variant.id));
        const r = await fetch(data.cart_add_url || cartPath + '/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!r.ok) { const payload = await r.json().catch(() => ({})); throw new Error(typeof payload.description === 'string' ? payload.description : ''); }
        window.location.href = redirect;
      } catch (e) {
        adding = false;
        buyButtons.forEach(button => button.classList.remove('is-busy'));
        $$('[data-arc-option]', root).forEach(button => { button.disabled = false; });
        form.setAttribute('aria-busy', 'false');
        render();
        if (errorMessage) {
          errorMessage.textContent = e.message && !(e instanceof TypeError) ? e.message : root.dataset.arcAddError;
          errorMessage.classList.remove('arc-hidden');
          errorMessage.focus();
        }
      }
    }
    $$('[data-arc-buy]', root).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart(checkoutPath); }));
    $$('[data-arc-add]', root).forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); addToCart(cartPath); }));
    if (form) form.addEventListener('submit', e => { const variant = findVariant(); if (adding || sizeNeedsChoice || !variant || !variant.available || data.price_on_request || variant.price > onRequestAbove) e.preventDefault(); });
    // thumbnails
    $$('[data-arc-thumb]', root).forEach(t => t.addEventListener('click', () => showMedia(root, t.dataset.arcThumb)));
    // sticky bar
    const hud = $('[data-arc-hud]', root);
    if (hud && sticky && 'IntersectionObserver' in window) {
      let hudVisible = false;
      const syncSticky = () => {
        const end = root.getBoundingClientRect().bottom;
        sticky.classList.toggle('is-visible', !hudVisible && end > window.innerHeight);
        const visible = sticky.classList.contains('is-visible') && !document.documentElement.classList.contains('arc-shero-on') && getComputedStyle(sticky).display !== 'none';
        sticky.setAttribute('aria-hidden', String(!visible));
        sticky.toggleAttribute('inert', !visible);
      };
      const io = new IntersectionObserver((en) => { hudVisible = en[0].isIntersecting; syncSticky(); }, { threshold: 0.05 });
      io.observe(hud);
      new MutationObserver(syncSticky).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      window.addEventListener('resize', syncSticky, { passive: true });
      window.addEventListener('scroll', syncSticky, { passive: true });
      syncSticky();
    }
    render(true);
    if (sizeNeedsChoice) sizeNotice?.focus({ preventScroll: true });
    window.addEventListener('pageshow', event => {
      if (!event.persisted || !adding) return;
      adding = false;
      form?.setAttribute('aria-busy', 'false');
      buyButtons.forEach(button => button.classList.remove('is-busy'));
      $$('[data-arc-option]', root).forEach(button => { button.disabled = false; });
      render(true);
      document.dispatchEvent(new Event('arc:cart-refresh'));
    });
    syncHint(root);
    fitTitles();
    // product videos: buffer once the page is idle, play ring if autoplay is refused
    $$('[data-arc-media-type="video"]', root).forEach(m => {
      const vid = $('video', m); if (!vid) return;
      m.style.position = 'relative';
      if (!m.querySelector('.arc-video-play')) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'arc-video-play'; b.setAttribute('aria-label', I18N.play || 'Play video'); b.innerHTML = '<span></span>';
        b.addEventListener('click', () => { vid.muted = true; vid.play().then(() => m.classList.remove('needs-tap')).catch(() => {}); });
        m.appendChild(b);
      }
      vid.addEventListener('error', () => m.classList.add('needs-tap'));
      // nothing is fetched until the visitor opens this media (showMedia loads and plays it)
      try { vid.preload = 'none'; vid.removeAttribute('autoplay'); } catch (e) {}
    });
  }
  function syncHint(root) {
    const active = $$('[data-arc-media-id]', root).find(m => !m.classList.contains('arc-hidden'));
    const rotatable = !!(active && active.dataset.arcMediaType === 'model') || !!$('.arc-spin', root);
    $$('.arc-hint, [data-arc-orbit]', root).forEach(h => h.classList.toggle('arc-hidden', !rotatable));
  }
  function showMedia(root, id) {
    $$('[data-arc-media-id]', root).forEach(m => {
      const on = m.dataset.arcMediaId === String(id);
      m.classList.toggle('arc-hidden', !on);
      const vid = m.tagName === 'VIDEO' ? m : $('video', m);
      if (vid) {
        if (on) {
          vid.muted = true; vid.setAttribute('playsinline', '');
          if (vid.preload !== 'auto') { vid.preload = 'auto'; try { vid.load(); } catch (e) {} }
          const p = vid.play();
          if (p && p.catch) p.then(() => m.classList.remove('needs-tap')).catch(() => m.classList.add('needs-tap'));
        } else { vid.pause(); }
      }
    });
    $$('[data-arc-thumb]', root).forEach(t => { const active = t.dataset.arcThumb === String(id); t.classList.toggle('is-active', active); t.setAttribute('aria-pressed', String(active)); });
    syncHint(root);
  }

  /* ---------- spin viewer (photo 360) ---------- */
  function initSpin(el) {
    const imgs = $$('img', el); if (imgs.length < 2) return;
    let i = 0, dragging = false, startX = 0, startI = 0, idle = null;
    const show = (n) => { i = ((n % imgs.length) + imgs.length) % imgs.length; imgs.forEach((im, k) => im.classList.toggle('is-current', k === i)); };
    show(0);
    const perFrame = Math.max(3, Math.round(el.clientWidth / imgs.length));
    el.addEventListener('pointerdown', (e) => { dragging = true; startX = e.clientX; startI = i; el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); clearInterval(idle); });
    el.addEventListener('pointermove', (e) => { if (!dragging) return; show(startI + Math.round((startX - e.clientX) / perFrame)); });
    const stop = () => { dragging = false; el.classList.remove('is-dragging'); };
    el.addEventListener('pointerup', stop); el.addEventListener('pointercancel', stop);
    if (!reduced && el.dataset.autorotate !== 'false') idle = setInterval(() => show(i + 1), 120);
  }

  /* ---------- tilt (3D card for prints) ---------- */
  function initTilt(el) {
    const inner = $('.arc-tilt__inner', el); if (!inner) return;
    let dragging = false, sx = 0, sy = 0, ry = parseFloat(el.dataset.ry || '-16'), rx = parseFloat(el.dataset.rx || '2'), by = ry, bx = rx;
    const set = () => { inner.style.setProperty('--arc-ry', ry + 'deg'); inner.style.setProperty('--arc-rx', rx + 'deg'); };
    set();
    el.addEventListener('pointerdown', (e) => { dragging = true; sx = e.clientX; sy = e.clientY; by = ry; bx = rx; el.classList.add('is-dragging'); el.setPointerCapture(e.pointerId); });
    el.addEventListener('pointermove', (e) => {
      if (dragging) { ry = Math.max(-60, Math.min(60, by + (e.clientX - sx) / 4)); rx = Math.max(-25, Math.min(25, bx - (e.clientY - sy) / 6)); set(); }
      else if (!reduced && matchMedia('(hover:hover)').matches) { const r = el.getBoundingClientRect(); ry = -16 + ((e.clientX - r.left) / r.width - .5) * 22; rx = 2 - ((e.clientY - r.top) / r.height - .5) * 12; set(); }
    });
    const stop = () => { dragging = false; el.classList.remove('is-dragging'); };
    el.addEventListener('pointerup', stop); el.addEventListener('pointercancel', stop);
    el.addEventListener('pointerleave', () => { if (!dragging) { ry = parseFloat(el.dataset.ry || '-16'); rx = parseFloat(el.dataset.rx || '2'); set(); } });
  }

  /* ---------- countdown ---------- */
  function initCountdown(el) {
    const t = Date.parse(el.dataset.arcCountdown); if (isNaN(t)) return;
    const d = $('[data-d]', el), h = $('[data-h]', el), m = $('[data-m]', el);
    const tick = () => {
      let s = Math.max(0, Math.floor((t - Date.now()) / 1000));
      const dd = Math.floor(s / 86400); s -= dd * 86400; const hh = Math.floor(s / 3600); s -= hh * 3600; const mm = Math.floor(s / 60);
      if (d) d.textContent = String(dd).padStart(2, '0'); if (h) h.textContent = String(hh).padStart(2, '0'); if (m) m.textContent = String(mm).padStart(2, '0');
    };
    tick(); setInterval(tick, 30000);
  }

  /* ---------- 3D model materials: the exports carry the art as rough metal, which renders grey ---------- */
  function tuneModel(mv) {
    try {
      const mats = mv.model && mv.model.materials; if (!mats) return;
      if (mv.dataset.arcTuned === '1') return;
      mats.forEach(m => {
        const pbr = m.pbrMetallicRoughness;
        const hasTex = !!(pbr.baseColorTexture && pbr.baseColorTexture.texture);
        const em = m.emissiveFactor || [0, 0, 0];
        const base = pbr.baseColorFactor || [1, 1, 1, 1];
        const name = (m.name || '').toLowerCase();
        if (hasTex && (em[0] > 0.5 || /cylind|sticker|etiquette/.test(name)) && !/cycle/.test(name)) {
          // the edition sticker cylinder: hide it
          try { m.setAlphaMode('BLEND'); } catch (e) {}
          pbr.setBaseColorFactor([0, 0, 0, 0]); m.setEmissiveFactor([0, 0, 0]); pbr.setMetallicFactor(0);
        } else if (hasTex) {
          // the printed art comes out of Blender as rough metal (grey in a viewer): light it from within, softly,
          // keep a glossy layer so the chrome streak still sweeps across it
          try { m.emissiveTexture.setTexture(pbr.baseColorTexture.texture); } catch (e) {}
          m.setEmissiveFactor([0.62, 0.62, 0.62]);
          pbr.setBaseColorFactor([0.28, 0.28, 0.28, 1]);
          pbr.setMetallicFactor(0.12); pbr.setRoughnessFactor(0.3);
        } else if (pbr.metallicFactor > 0.9 && pbr.roughnessFactor < 0.1 && base[0] > 0.5) {
          // the mirror plate
          pbr.setRoughnessFactor(0.06);
        }
      });
      mv.dataset.arcTuned = '1';
    } catch (e) {}
  }

  /* ---------- idle sway: a slow float, never the back of the piece; stops while the visitor drags ---------- */
  function swayModel(mv) {
    let last = 0; const t0 = performance.now();
    mv.addEventListener('camera-change', (e) => { if (e.detail && e.detail.source === 'user-interaction') last = performance.now(); });
    mv.addEventListener('pointerdown', () => { last = performance.now(); });
    function tick(now) {
      if (!document.hidden && now - last > 5000 && !mv.classList.contains('arc-hidden') && !(mv.closest('.arc-hidden'))) {
        const t = (now - t0) / 1000;
        mv.cameraOrbit = (-22 + 9 * Math.sin(t / 3.6)) + 'deg ' + (80 + 2.5 * Math.sin(t / 5.3)) + 'deg ' + (mv.dataset.arcRadius || 110) + '%';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  /* ---------- room videos load only when near, story unfolds on demand ---------- */
  function initLazyMedia() {
    $$('video[data-arc-lazy-video]').forEach(v => {
      const ready = () => v.classList.add('is-ready');
      ['loadeddata', 'canplay', 'playing'].forEach(ev => v.addEventListener(ev, ready, { once: true }));
      setTimeout(ready, 5000);
      const box = v.parentElement;
      const load = () => { if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = v.dataset.src; v.load(); } };
      // a play ring when autoplay is refused (low-power mode, data saver)
      const tryPlay = () => v.play().then(() => box.classList.remove('needs-tap')).catch(() => box.classList.add('needs-tap'));
      if (box && !box.querySelector('.arc-video-play')) {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'arc-video-play'; b.setAttribute('aria-label', I18N.play || 'Play video'); b.innerHTML = '<span></span>';
        b.addEventListener('click', () => { load(); v.muted = true; tryPlay(); });
        box.appendChild(b);
      }
      v.addEventListener('error', () => box && box.classList.add('needs-tap'));
      // load only when the visitor gets near it (a 5 MB clip stays untouched for people who never scroll there)
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((en) => { if (en.some(e => e.isIntersecting)) { load(); io.disconnect(); } }, { rootMargin: '700px 0px' });
        io.observe(v);
      } else load();
      if (!('IntersectionObserver' in window)) { load(); tryPlay(); return; }
      const io = new IntersectionObserver(en => { en.forEach(e => { if (e.isIntersecting) { load(); tryPlay(); } else { v.pause(); } }); }, { rootMargin: '600px 0px' });
      io.observe(v);
    });
    $$('[data-arc-story-toggle]').forEach(b => b.addEventListener('click', () => { const body = b.previousElementSibling; if (body) body.classList.remove('is-collapsed'); b.remove(); }));
    // hotspots: one open at a time, hover on desktop, tap on touch
    $$('[data-arc-hotspots]').forEach(box => {
      const dots = $$('[data-arc-hot]', box);
      const open = (id) => { dots.forEach(d => { const on = d.dataset.arcHot === id; d.classList.toggle('is-open', on); d.setAttribute('aria-expanded', on ? 'true' : 'false'); }); $$('[data-arc-hot-card]', box).forEach(c => c.classList.toggle('is-open', c.dataset.arcHotCard === id)); };
      dots.forEach(d => {
        d.addEventListener('click', (e) => { e.preventDefault(); open(d.classList.contains('is-open') ? null : d.dataset.arcHot); });
        d.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) open(d.dataset.arcHot); });
      });
      box.addEventListener('mouseleave', () => open(null));
      document.addEventListener('click', (e) => { if (!box.contains(e.target)) open(null); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initLazyMedia); else initLazyMedia();

  /* ---------- colourway thumbnails on cards: hover previews the colour on the card ---------- */
  function initSwatchRows() {
    $$('.arc-swatch-row').forEach(row => {
      const card = row.closest('.arc-print-card'); if (!card) return;
      const main = $('.arc-print-card__main', card); const alt = $('.arc-print-card__alt', card); if (!main) return;
      const original = { src: main.getAttribute('src'), srcset: main.getAttribute('srcset') };
      $$('.arc-swatch-thumb', row).forEach(t => t.addEventListener('mouseenter', () => {
        main.removeAttribute('srcset'); main.src = t.dataset.arcSwatchImg; card.classList.add('is-previewing');
      }));
      row.addEventListener('mouseleave', () => { if (original.srcset) main.setAttribute('srcset', original.srcset); main.src = original.src; card.classList.remove('is-previewing'); });
      if (alt) card.addEventListener('mouseleave', () => card.classList.remove('is-previewing'));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSwatchRows); else initSwatchRows();

  /* ---------- modals (size guide) ---------- */
  function initModals() {
    $$('[data-arc-open]').forEach(b => b.addEventListener('click', () => { const d = document.getElementById(b.dataset.arcOpen); if (d && d.showModal && !d.open) d.showModal(); }));
    $$('.arc-modal').forEach(d => {
      d.addEventListener('click', (e) => { if (e.target === d) d.close(); });
      $$('[data-arc-close]', d).forEach(c => c.addEventListener('click', () => d.close()));
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initModals); else initModals();

  /* ---------- HUD title: one line, shrink to fit ---------- */
  function fitTitles() {
    $$('.arc-product__title').forEach(el => {
      el.style.fontSize = ''; el.style.whiteSpace = 'nowrap';
      let size = parseFloat(getComputedStyle(el).fontSize) || 32; let guard = 0;
      while (el.scrollWidth > el.clientWidth && size > 16 && guard++ < 40) { size -= 1; el.style.fontSize = size + 'px'; }
      if (el.scrollWidth > el.clientWidth) el.style.whiteSpace = '';
    });
  }
  let fitTimer = null;
  window.addEventListener('resize', () => { clearTimeout(fitTimer); fitTimer = setTimeout(fitTitles, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitTitles);

  /* Native 3D print pool with the store's real related colourways. */
  function initHeroPool() {
    const hero = $('[data-arc-hero-pool]');
    if (!hero || hero.dataset.arcPoolReady === '1') return;
    const jsonEl = $('[data-arc-hero-json]', hero), mv = $('[data-arc-hero-model]', hero);
    if (!jsonEl || !mv) return;
    let pool;
    try { pool = JSON.parse(jsonEl.textContent) || []; } catch (_) { return; }
    if (!pool.length) return;
    hero.dataset.arcPoolReady = '1';
    document.documentElement.classList.add('arc-hero3d');
    let last = -1;
    try { last = parseInt(localStorage.getItem('arc-hero-last') || '-1', 10); } catch (_) {}
    let index = Math.floor(Math.random() * pool.length);
    if (pool.length > 1 && index === last) index = (index + 1 + Math.floor(Math.random() * (pool.length - 1))) % pool.length;
    try { localStorage.setItem('arc-hero-last', String(index)); } catch (_) {}
    const family = pool[index];
    const choices = family.v && family.v.length ? family.v : [family];
    const group = $$('[data-arc-hero-colourset]', hero).find(el => el.dataset.arcHeroColourset === String(family.id));
    $$('[data-arc-hero-colourset]', hero).forEach(el => { el.hidden = el !== group; });
    let current = choices[0], started = false;
    const photo = $('[data-arc-hero-photo]', hero);
    const stage = mv.closest('.arc-stage');
    const set = (selector, text) => $$(selector, hero).forEach(el => { el.textContent = text || ''; });
    function select(choice) {
      current = choice;
      hero.classList.remove('is-3d');
      mv.classList.remove('is-loaded');
      delete mv.dataset.arcTuned;
      mv.dataset.arcRadius = '102';
      mv.removeAttribute('src');
      mv.setAttribute('alt', (choice.t || family.t || '') + ' 3D');
      if (photo && choice.i) { photo.src = choice.i; photo.alt = choice.t || family.t || ''; }
      if (stage) stage.setAttribute('aria-busy', 'true');
      set('[data-arc-hero-title]', choice.t || family.t);
      set('[data-arc-hero-price]', choice.p);
      const colour = $('[data-arc-hero-colour]', hero);
      if (colour) { colour.textContent = choice.c || ''; colour.closest('.arc-row').hidden = !choice.c; }
      $$('[data-arc-hero-link]', hero).forEach(link => { link.href = choice.u; });
      if (group) $$('[data-arc-hero-choice]', group).forEach(button => {
        const selected = button.dataset.arcHeroChoice === String(choice.id);
        button.classList.toggle('is-active', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (started) mv.setAttribute('src', current.g);
    }
    mv.addEventListener('load', () => {
      hero.classList.add('is-3d');
      mv.classList.add('is-loaded');
      if (stage) stage.setAttribute('aria-busy', 'false');
    });
    mv.addEventListener('error', () => {
      hero.classList.remove('is-3d');
      if (stage) stage.setAttribute('aria-busy', 'false');
    });
    if (group) group.addEventListener('click', event => {
      const button = event.target.closest('[data-arc-hero-choice]');
      if (!button || !group.contains(button)) return;
      const choice = choices.find(item => String(item.id) === button.dataset.arcHeroChoice);
      if (!choice || choice.id === current.id) return;
      started = true;
      select(choice);
    });
    select(current);
    const begin = () => {
      const idle = window.requestIdleCallback || (fn => setTimeout(fn, 300));
      idle(() => { if (started) return; started = true; mv.setAttribute('src', current.g); });
    };
    if (document.readyState === 'complete') begin(); else window.addEventListener('load', begin, {once:true});
    setTimeout(() => {
      if (window.customElements && customElements.get('model-viewer')) return;
      const load = () => {
        if (customElements.get('model-viewer')) return;
        const script = document.createElement('script');
        script.type = 'module'; script.src = 'https://cdn.shopify.com/shopifycloud/model-viewer/v1.12/model-viewer.min.js';
        document.head.appendChild(script);
      };
      if (window.Shopify && window.Shopify.loadFeatures) {
        try { window.Shopify.loadFeatures([{name:'model-viewer',version:'1.12',onLoad:()=>{}}]); } catch (_) {}
        setTimeout(load, 2500);
      } else load();
    }, 1500);
  }


  /* ---------- 3D model (Shopify model-viewer UI) ---------- */
  function initModels() {
    const models = $$('.arc-stage model-viewer, .arc-card__media model-viewer');
    if (!models.length || !window.Shopify || !window.Shopify.loadFeatures) return;
    models.forEach(mv => {
      // direct rotation, page still scrolls with one finger, slow idle turn, slightly tilted like the mockup
      mv.setAttribute('touch-action', 'pan-y');
      mv.setAttribute('interaction-prompt', 'none');
      mv.removeAttribute('auto-rotate');
      mv.setAttribute('shadow-intensity', '0');
      mv.setAttribute('disable-zoom', '');
      // A separate product photo stays visible until the actual model is ready.
      // Shopify's generated poster can be a grey square, so do not use it.
      mv.removeAttribute('poster');
      const modelBox = mv.closest('.arc-model');
      if (modelBox) modelBox.setAttribute('aria-busy', 'true');
      const reveal = () => {
        mv.classList.add('is-loaded');
        requestAnimationFrame(() => requestAnimationFrame(() => {
          if (modelBox && mv.loaded) {
            modelBox.classList.add('is-ready');
            modelBox.setAttribute('aria-busy', 'false');
          }
        }));
      };
      mv.addEventListener('load', reveal);
      mv.addEventListener('error', () => {
        mv.classList.remove('is-loaded');
        if (modelBox) {
          modelBox.classList.remove('is-ready');
          modelBox.setAttribute('aria-busy', 'false');
        }
      });
      if (mv.loaded) reveal();
      mv.removeAttribute('camera-target');
      mv.removeAttribute('field-of-view');
      const applyOrbit = () => {
        const r = Number(mv.dataset.arcRadius || 110);
        mv.setAttribute('camera-orbit', '-22deg 80deg ' + r + '%');
        mv.setAttribute('min-camera-orbit', 'auto auto ' + Math.max(100, Math.round(r * 0.85)) + '%');
        mv.setAttribute('max-camera-orbit', 'auto auto ' + Math.round(r * 1.6) + '%');
      };
      applyOrbit();
      // Home uses a closer 102% camera; other print viewers keep the verified 110% margin
      mv.addEventListener('load', () => {
        try {
          const r = mv.hasAttribute('data-arc-hero-model') ? 102 : 110;
          if (String(r) !== mv.dataset.arcRadius) { mv.dataset.arcRadius = String(r); applyOrbit(); }
        } catch (e) {}
      });
      // studio strip light for the mirror surfaces (LDR equirect), a bit more exposure to compensate
      const wrap = mv.closest('[data-arc-env]');
      if (wrap && wrap.dataset.arcEnv) { mv.setAttribute('environment-image', wrap.dataset.arcEnv); mv.setAttribute('exposure', '1.35'); }
      mv.addEventListener('load', () => { tuneModel(mv); setTimeout(() => tuneModel(mv), 400); });
      if (mv.loaded) tuneModel(mv);
      swayModel(mv);
    });
    window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: () => {
      models.forEach(mv => {
        try {
          const ui = new window.Shopify.ModelViewerUI(mv, { focusOnPlay: false });
          const play = () => {
            try { if (ui && typeof ui.play === 'function') ui.play(); } catch (e) {}
            const b = mv.parentElement && mv.parentElement.querySelector('.shopify-model-viewer-ui__button--poster');
            if (b) b.click();
            mv.setAttribute('camera-controls', '');
          };
          play(); setTimeout(play, 800); setTimeout(play, 2500);
        } catch (e) {}
      });
    } }]);
  }

  function init() {
    initHeader(); initReveal(); initHeroPool(); initModels();
    $$('[data-arc-product]').forEach(initProduct);
    $$('.arc-spin').forEach(initSpin);
    $$('.arc-tilt').forEach(initTilt);
    $$('[data-arc-countdown]').forEach(initCountdown);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
